import React from "react";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";
import { InputSwitch } from "primereact/inputswitch";
import { InputSwitchChangeEvent } from "primereact/inputswitch";
import { ThemeName } from "types/theme";
import { Typography } from "ui-kit/Typography";

interface ThemeControlProps {
  checked: boolean;
  onChangeTheme: (theme: ThemeName) => void;
  open?: boolean
}

export const ThemeControls: React.FC<ThemeControlProps> = props => {
  const onToggleTheme = (event: InputSwitchChangeEvent) => {
    // TODO Временно задизейблено
    // if (event.value) {
    //   props.onChangeTheme(ThemeName.Dark);
    // } else {
    //   props.onChangeTheme(ThemeName.Light);
    // }
  };

  return (
    <Container style={{
      flexDirection: props.open ? "unset" : "column",
      padding: props.open ? "4px 5px" : "4px 3px"
    }}>
      <Button htmlFor="theme-controller" $isActive={!props.checked} style={{
        padding: props.open ? "6px 10px" : "4px 3px",
        borderRadius: props.open ? '30px' : '50%',

      }}>
        <span style={{
          width: 'auto',
          height: 'auto',
          marginTop:  !props.open ?'-1px': '0'
        }}>
          ☀️
        </span>
        {props.open && <Typography variant="subtitle1">
          <FormattedMessage
            id="ThemeControls.Light"
            defaultMessage="Light mode"
            description="Light mode"
          />
        </Typography>}
      </Button>
      <Button htmlFor="theme-controller" $isActive={props.checked}>
        🌑️
        {props.open && <Typography variant="subtitle1">
          <FormattedMessage
            id="ThemeControls.Dark"
            defaultMessage="Dark mode"
            description="Dark mode"
          />
        </Typography>}
      </Button>
      <StyledToggleButton
        inputId="theme-controller"
        checked={props.checked}
        onChange={onToggleTheme}
      />
    </Container>
  )
};

const StyledToggleButton = styled(InputSwitch)`
  display: none;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  border-radius: 30px;
  background-color: ${props => props.theme.palette.background.themeController};
`;

const Button = styled.label<{ $isActive?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 10px;
  gap: 10px;
   flex: 1;
  cursor: pointer;
  background-color: ${props => props.$isActive ? props.theme.palette.background.themeControllerActive : 'transparent'};
`;
